<!-- Security Header -->
<app-settings-header
  [headerTitle]="'API.API'"
  subtitle="API.manageYourApiKeys"
  [showTourIcon]="true"
  (onTour)="startApiTour()"
></app-settings-header>

<!-- TODO:  [showTourIcon]="true"
  (onTour)="startSecurityTour()"
-->

<!-- Api key Section -->
<app-settings-section
  [sectionTitle]="'API.previouslyGeneratedApiKeys' | translate"
  [subtitle]="getSubtitle()"
  [horizontal]="true"
  [showButton]="true"
  (buttonClick)="generateApiKey()"
  buttonText="API.generateNewApiKey"
  buttonIcon="ph ph-plus"
  [buttonId]="'generate-new-api-key'"
>
  <!-- Desktop version -->
  @if (this.getApiKey()) {
    <div class="table-container">
      <table class="api-table">
        <thead>
          <tr>
            @for (headerLabel of tableHeaders; track headerLabel) {
              <th [class]="getHeaderClass($index)">
                {{ headerLabel | translate }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (apiKey of demoApiKeys; track apiKey.id) {
            <!-- Main row -->
            <tr class="api-row">
              <td>
                <button class="expand-button" (click)="toggleRow($event, apiKey.id)">
                  <i class="ph w-3" [class]="getExpandIconClass(apiKey.isExpanded)"></i>
                </button>
              </td>
              <td>{{ apiKey.type | translate }}</td>
              <td>{{ getApiKey() }}</td>
              <td>
                <span class="status-badge">{{ apiKey.status | translate }}</span>
              </td>
              <td>{{ getDate() ? ('API.createdOn' | translate: { createdDate: getDate() }) : '---' }}</td>
              <td>
                <button class="revoke-button" (click)="revokeApiKey()">
                  <span>{{ 'API.revoke' | translate }}</span>
                </button>
              </td>
            </tr>

            <!-- Expandable content -->
            @if (apiKey.isExpanded) {
              <tr class="bg-white">
                <td colspan="7" class="bg-white py-3 px-2">
                  <div class="scope-content p-3 bg-gray-100 rounded-lg">
                    <div class="text-sm font-normal text-gray-400">{{ 'API.permissions' | translate }}:</div>
                    @for (scope of apiKey.scopes; track scope) {
                      <div class="scope-item flex flex-row items-center py-2 gap-2">
                        <div class="font-medium w-50 whitespace-normal" title="{{ scope.name | translate }}">
                          {{ scope.name | translate }}
                        </div>
                        <i class="ph ph-arrow-right"></i>
                        <div class="text-gray-400 font-normal" title="{{ scope.description | translate }}">
                          {{ scope.description | translate }}
                        </div>
                        <button class="docs-link shrink-0 ml-auto" (click)="redirectToApiDocs(scope.link)">
                          <i class="ph ph-arrow-line-up-right"></i>
                        </button>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  } @else {
    {{ 'API.thereIsNoApiKeySettingAvailableRightNow' | translate }}
  }

  <!-- Mobile version -->
  @if (this.getApiKey()) {
    <div class="block sm:hidden">
      <!-- Mobile card -->
      <div class="p-3 border-2 border-#ECECEC rounded-xl flex flex-wrap gap-3 bg-white">
        <!-- card header -->
        <div class="flex flex-nowrap w-full items-center gap-2">
          <i class="ph ph-key"></i>
          <h3 class="font-bold">Api</h3>
        </div>

        <!-- card status -->
        <div class="flex flex-nowrap w-full justify-between">
          <span
            class="bg-[#DBF6CB] capitalize cursor-default font-medium px-3 py-1 rounded-full text-[#006E3B] text-xs"
            >{{ 'API.active' | translate }}</span
          >
        </div>

        <!-- Api key label -->
        <div class="flex flex-nowrap w-full justify-between font-normal">
          <label class="text-[#929292] font-normal">{{ 'API.apiKeyLast5Characters' | translate }}</label>
          <label class="font-normal">{{ getApiKey() }}</label>
        </div>

        <!-- date label  -->
        <div class="flex flex-nowrap w-full justify-between items-baseline font-normal">
          <label class="text-[#929292] font-normal">
            {{ 'API.createdOn' | translate: { createdDate: getDate() } }}</label
          >
          <button (click)="revokeApiKey()">
            <span class="text-left font-medium text-red-500 underline">{{ 'API.revoke' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  }
</app-settings-section>
